import script from "./ContractDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./ContractDeleteModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__